// GENERIC NON-AXOS RELATED ROUTINES
//
import * as tf from '@tensorflow/tfjs';
import { CONSLOG, INFO, CONES } from '../util/object';
import { analyzeHistogram } from "../util/util";   // test only
import { findNextTarget, 
         lockCones,        // lock and filter cones before setting the home zone
         setPlayerHomeZone,
         determineReverse,
         prepareCones,            // this is used to calc "goal reached zone"
         setFakeCones } from './performance';

// prints current tf.memory
/* call with: 
import { TFMem } from '../util/tools'
TFMem("caller1");
/*
  tf.memory()
    numBytes: 77009396
    numBytesInGPU: 80847128
    numBytesInGPUAllocated: 567804644
    numBytesInGPUFree: 486957516
    numDataBuffers: 389
    numTensors: 392
    unreliable: false
*/
const REPORT_TF_MEM=true;
var last_mem = null;

export function pickRandomIndex(max0) {
    var max = (max0 == undefined) ? 100 : max0;
    var seed = (performance.now() * 100000000) % 10000; 
    seed = Math.floor(seed + (Math.random() * 54541) + (seed * 90437));
    var random = seed % max;
    //console.log("random.611: ....................  seed=",Math.floor(seed), " max=", max, " random=", random);
    return random;
}

// DEBUG ONLY: Determine 2-cone Random function distribution
export async function test2ConeRandom() {
    var trials = 100;
    var buckets = 10;
    var out1=[], out2=[], idx1, idx2;

    var CONE_CNT = 4;
    INFO.no_ai_mode = true;
    INFO.active_goals = 2;
	INFO.out_canvas = null;     // test special case it lower
    INFO.image_width = 600;
    INFO.image_height = 400;

    setFakeCones(CONE_CNT);
    console.log("test2c: SEED TARGET CONES=", CONES);
    setPlayerHomeZone();
    lockCones(true);        // lock and filter cones before setting the home zone
    prepareCones();            // this is used to calc "goal reached zone"
    console.log("test2c: FINAL CONES=", CONES);

    var loop = 0;
    INFO.rep_run_cnt = 0;
    for(var i= 0; i < trials; i++) {
        idx1 = findNextTarget(false);
        out1[i] = {"v": idx1};
        if (determineReverse() == true) {
            //idx2 = findNextTarget(true);
            idx2 = 1;   // "SWITCH"
        } else {
            idx2 = 0;   // ""
        }
        out2[i] = {"v": idx2};
        console.log(loop+": ", idx1, " =>", idx2);

        await sleep (Math.random() * 3);
        loop = loop + 1;
        INFO.rep_run_cnt = INFO.rep_run_cnt + 1;
    }

    console.log("test_random:  GEN done  ", out1);
    var [fbkt, favg] = analyzeHistogram(out1, "v", true, 1, buckets);
    console.log("test_random:  BUCKET COMPLETE  ", fbkt,  "  avg=",favg);
}


// DEBUG ONLY: Determine Random function distribution
export async function testBigRandom() {
    var out=[];
    for(var i= 0; i < 10000; i++) {
        out[i] = {"v": pickRandomIndex(1000)};
        await sleep (Math.random() * 3);
    }

    //console.log("test_random:  GEN done  ", out);
    var [fbkt, favg] = analyzeHistogram(out, "v", true, 1000, 10);
    console.log("test_random:  BUCKET COMPLETE  ", fbkt,  "  avg=",favg);
}

// check the tensorflow memory
export const TFMem = (caller) => {
    if(REPORT_TF_MEM == false)
        return;

    var mem = tf.memory();
    if(last_mem !== null) {
        var bytes_used = mem.numBytes - last_mem.numBytes;
        var gpu_bytes = mem.numBytesInGPU - last_mem.numBytesInGPU;
        var gpu_free = mem.numBytesInGPUFree - last_mem.numBytesInGPUFree;
        var gpu_alloc = mem.numBytesInGPUAllocated - last_mem.numBytesInGPUAllocated;
        var tensor_used = mem.numTensors - last_mem.numTensors;
        var buf_used = mem.numDataBuffers- last_mem.numDataBuffers;
        console.log(caller+":  tensor=", tensor_used, " buf=", buf_used,
                    "  gpu_bytes=", gpu_bytes, "  gpu_free=", gpu_free, "  gpu_alloc=", gpu_alloc)
    }
    last_mem = {...mem};    // use spread to make a copy
}


// set the element offsetHeight
//
export function setOffsetHeight(el, hh) {
    el.style.height = hh+"px";
    var diff = el.offsetHeight - hh;
    el.style.height = el.offsetHeight - diff;
}


// set the element offsetWidth, important for responsive formatting
//
export function setOffsetWidth(el, ww) {
    el.style.width = ww+"px";
    var diff = el.offsetWidth - ww;
    el.style.width = el.offsetWidth - diff;
    //console.log("setOffWid.66: ........... ww=",ww, " diff=", diff, "  final.w=", el.style.width);
}


function dateToVersion() {
    var now = new Date();
    var mon = now.getMonth()+1;
    var dat = now.getDate();
    var hou = now.getHours();
    var min = now.getMinutes();
    mon = (mon < 10) ? "0"+mon : mon;
    dat = (dat < 10) ? "0"+dat : dat;
    hou = (hou < 10) ? "0"+hou : hou;
    min = (min < 10) ? "0"+min : min;
    var ver = "v."+mon+dat+"-"+hou+min;
    return ver;
}


// google analytics tag for tracking
export const GATag = (category, action, label, value) => { 
    //if (!window.ga) return warn('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
    //return window.ga(...args);
    window.gtag('event', 
         action, 
        {
            'event_category': category,
            'event_label': label,
            'value': value
        }
    );
}

// returns if running on iphone
export const Iphone = () => {
	var ua  = navigator.userAgent;
	//console.log("********* Iphone: ua=", ua);
	return ~ua.indexOf('iPhone');
}

// convert caller IP address to ID (phone #) for non-PTSN connections (like Cari)
// 123.456.789.012
// 2601:647:5600:2c4:90f9:8e6c:81e6:cdad
const IP2ID = (ip) => {
    var ipnumb, hex, sum=0;
    if(ip.length > 16) {
        // IP V6 format: 2601:647:5600:2c4:90f9:8e6c:81e6:cdad
        // convert to integer, create staggered sum
        var nip=ip.replace(/:/g, "")
        for(var i = 0; i < nip.length; i=i+2) {
            hex = nip.substr(i, 2);
            sum = (sum*4) + parseInt(hex,16);
            //console.log(sum);
        }
        ipnumb = sum.toString();

    } else {
        ipnumb = ip.replace(/\./g, "");
    }
    return("+100"+ipnumb);
}


/* MOVED
// MISC UTILITY FUNCTIONS
export class UtilClass {
    constructor() {
    }

    getIphoneModel(renderer) {
            switch (renderer) {
                case "S5L8900":
                    return "1";
                    //return "iPhone 1, 3G";
                case "ALP0298C05":
                    return "3";
                    //return "iPhone 3GS";
                case "PowerVR SGX 535":
                    return "4";
                    //return "iPhone 4";
                case "PowerVR SGX 543":
                    return "5";
                    //return "iPhone 5 or 5c";
                case "Apple A7 GPU":
                    return "5";
                    //return "iPhone 5s";
                case "Apple A8 GPU":
                    return "6";
                    //return "iPhone 6 Plus";
                case "Apple A9 GPU":
                    return "6";
                    //return "iPhone 6s Plus";
                case "Apple A10 GPU":
                    return "7";
                    //return "iPhone 7 Plus";
                case "Apple A11 GPU":
                    return "8";
                    //return "iPhone 8 Plus";
                default:
                    return "8";
                    //return "iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus";
            }
    }

    // returns [ model: 6, 7, 8, XS,  mode: normal, zoom]
    getIphoneDevice() {
        // Create a canvas element which can be used to retrieve information about the GPU.
        var canvas = document.createElement("canvas");
        if (canvas) {
            var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
            if (context) {
                var info = context.getExtension("WEBGL_debug_renderer_info");
                if (info) {
                    var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
                }
            }
        }
        var model = this.getIphoneModel(renderer);

        // iPhone X
        if ((window.screen.height / window.screen.width == 812 / 375) && (window.devicePixelRatio == 3)) {
            return ["x", "normal"];

        // iPhone 6+/6s+/7+ and 8+
        } else if ((window.screen.height / window.screen.width == 736 / 414) && (window.devicePixelRatio == 3)) {
            return [model, "normal"];

        // iPhone 6+/6s+/7+ and 8+ in zoom mode
        } else if ((window.screen.height / window.screen.width == 667 / 375) && (window.devicePixelRatio == 3)) {
            return [model, "zoom"];

        // iPhone 6/6s/7 and 8
        } else if ((window.screen.height / window.screen.width == 667 / 375) && (window.devicePixelRatio == 2)) {
            return [model, "normal"];

        // iPhone 5/5C/5s/SE or 6/6s/7 and 8 in zoom mode
        } else if ((window.screen.height / window.screen.width == 1.775) && (window.devicePixelRatio == 2)) {
            return [model, "zoom"];

        // iPhone 4/4s
        } else if ((window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 2)) {
            return [model, "normal"];

        // iPhone 1/3G/3GS
        } else if ((window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 1)) {
            return [model, "normal"];
        } else {
            return ["unknown", "normal"];
        }
    }

    // returns [SIZE: tv, pc, tablet, phone  TYPE: iphone, android, mac, win, MODEL: X, 9, 8]
    getDeviceType() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return ["phone", "android", "window"];

        } else if (/android/i.test(userAgent)) {
            //return ["android", dev_type, dev_model];
            return ["phone", "android", "unknown"];

        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            // iphone detection from: http://stackoverflow.com/a/9039885/177710
            var dev_type="unknown"
            var dev_model="unknown"
            if (/iPhone/.test(userAgent)) {
                const [dev_model, zoom] = this.getIphoneDevice();
                return ["phone", "iphone", dev_model];

            } else if (/iPad/.test(userAgent)) {
                return ["tablet", "iphone", dev_model];

            } else if (/iPod/.test(userAgent)) {
                dev_type = "ipod"
                return ["phone", "iphone", "ipod"];
            }

        } else if (/Mac/.test(userAgent)) {
            return ["pc", "mac", "mac"]

        } else {
            //return ["pc", "win", "win"]
            return ["phone", "android", "android"]
        }

        return ["unknown", "unknown", "unknown"]
    }
}

export function isiOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}

export function isMobile() {
    return isAndroid() || isiOS();
}

*/




// returns stack
export const Stack = (stack) => {
    var bits = stack.split("\n");
    if(bits.length >= 3) {
        var callers = bits[2].split(" ");
        if(callers.length >= 6) {
            return callers[5];
        }
    }
    return "NA";

}


export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}



//export { Util }